import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SETTINGS } from '../configs/common.settings';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(private http: HttpClient) {}

  postFile(file: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${SETTINGS.BASE_API}/files/upload`, formData);
  }

  downloadFile(fileName: string): Observable<Blob> {
    return this.http.post(
      `${SETTINGS.BASE_API}/files/download`,
      {
        fileName,
      },
      {
        responseType: 'blob',
        headers: { 'Access-Control-Allow-Origin': '*' },
      }
    );
  }
}
